/*
 *
 * Widgets constants
 *
 */

export const FETCH_WIDGET = 'app/Widgets/FETCH_WIDGET';
export const FETCH_WIDGET_SUCCESS = 'app/Widgets/FETCH_WIDGET_SUCCESS';
export const UPDATE_WIDGET_SUCCESS = 'app/Widgets/UPDATE_WIDGET_SUCCESS';
export const FETCH_WIDGET_FAILURE = 'app/Widgets/FETCH_WIDGET_FAILURE';

export const EXPORT_WIDGET = 'app/Widgets/EXPORT_WIDGET';

export const REMOVE_WIDGET = 'app/Widgets/REMOVE_WIDGET';

export const RESET_WIDGETS = 'app/Widgets/RESET_WIDGETS';
